module.exports = __webpack_public_path__ + "img/icons8-secured-letter-50.52f95912.svg";